<template>
<div style="position:relative">

    <slot :items="items" :teams="teamNames">
        <template v-for="item in items">
            <ObjectViewer :item="item" />
        </template>
    </slot>
    <template v-if="status == 'loading'">
        <slot name="loader" >
            <div style="text-align:center"  class="pa-3">
                <v-progress-circular indeterminate class="grey--text"></v-progress-circular>
            </div>
        </slot>    
    </template>
    <template v-if="moreItemsAvailable">  
        <slot name="more">
            <div  style="text-align:center" class="pa-3">
                <v-btn rounded depressed @click="itemLimit += limit">Load More...</v-btn>
            </div>
        </slot>
    </template>
    <template v-if="status == 'loaded' && items.length == 0">
        <slot name="empty">
            <div  style="text-align:center;font-size:20px;color:rgba(68,68,68,0.2);" class="pa-3">
                No Data
            </div>
        </slot>
    </template>

</div>
</template>

<script>
import ObjectViewer from '../ui-elements/ObjectViewer'
import DataHelpers from '../helpers/DataHelpers'
import Firestore from '../data/Firestore'
import NumberHelpers from '../helpers/NumberHelpers'
import TeamHelpers from '../helpers/TeamHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import ArrayHelpers from '../helpers/ArrayHelpers'
import CollectionHelpers from '../helpers/CollectionHelpers'


export default {
    data() {
        return {
            data: {},
            status: '',
            itemLimit: this.limit || 100,
            teamNames: [],
            items: []
        }
    },

    components: {
        ObjectViewer,
    },
    
    props: {
        collection: String,
        conditions: {
            type: Array,
            default: function() {
                return []
            }
        },
        limit: Number,
        sortField: String,
        search: String,
    },

    computed: {

        moreItemsAvailable() {
            return (this.items.length >= this.itemLimit)
        },
    },

    methods: {
        addItem(item) {
            CollectionHelpers.insertOrMoveToTop(item, this.items)
        },

        async loadData() {
            console.log('DataLoader > loadData')
            this.status = 'loading'
            this.$emit('loading')
            let refs = []
            this.teamNames.forEach(team => {
                    
                let ref = Firestore.getFirestore().collection(`teams/${team}/collections/${this.collection}/data`)

                if(this.search) {
                    //Search is active
                    //todo: enable variable number of search fields
                    for(let i = 1; i < 4; i++) {
                        const field = 'search' + i
                        const refSearch = ref.where(field, '>=', this.search)
                            .where(field, '<', this.search + '\uf8ff').limit(30)
                        refs.push(refSearch)
                    }
                } else {
                    //Not search...do normal conditions
                    this.conditions.forEach(condition =>{
                        ref = ref.where(condition.field, condition.operator, condition.value)
                    })
                    ref = ref.limit(this.itemLimit)
                    refs.push(ref)
                }
            })
            let mergedItems = await Firestore.fetchMulti(refs)
            
            const sortField = this.sortField
            if(sortField)
                mergedItems = mergedItems.sort((a,b) => OrderHelpers.sortByField(a, b, sortField))
            
            this.items = mergedItems.map(item => {
                    let enhancedItem = {...item, _sourceArray: mergedItems}
                    return enhancedItem
            })
            this.$emit('loaded', this.items)
            this.status = 'loaded'
         
        },
    },

    watch: {
        'sortField': {
            handler: function(newVal) {
                console.log('sortField watcher')
                this.items = this.items.sort((a,b) => OrderHelpers.sortByField(a, b, newVal))
            }
        },
        'itemLimit': {
            handler: function(newVal) {
                console.log('itemLimit watcher')
                this.loadData()
            }
        },
        'search': {
            handler: function(newVal) {
                console.log('search watcher')
                this.loadData()
            }
        },
        'conditions': {
            handler: function(newVal) {
                console.log('conditions watcher')

                this.loadData()
            },
            deep: true,
        },
    },

    created() {
        console.groupCollapsed('DataLoader')
        TeamHelpers.fetchActiveTeams().then(teams => {
            this.teamNames = teams.map(team => team._id)
            console.log('Teams:', this.teamNames)
            this.loadData()
            console.groupEnd()
        })

    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DataLoader.vue?b409273a